module.exports = __webpack_public_path__ + "img/sample.3f419f53.png";